<template>
  <div class="accessibility">
    <h1>Accessibility</h1>
    <div class="wrapper">
      <div class="single-accessibility">
        <h2>Post new accessibility</h2>
        <button v-if="!postNew" @click="setPostNew(true)" class="showButton">
          Post new accessibility
        </button>
        <div v-if="postNew">
          <div class="post-item-wrap">
            <label for="acc-dropdown">Select the location:</label>
            <select id="acc-dropdown" v-model="loc_id">
              <option
                v-for="el in locations"
                :key="el.loc_id"
                :value="el.loc_id"
              >
                {{ el.loc_id }}. {{ el.loc_name }} ({{
                  el.ltp_code ? el.ltp_code : ""
                }})
              </option>
            </select>
            <small> *You either choose location or the action </small>
          </div>
          <div class="post-item-wrap">
            <label for="post-item-wrap">Or select the action:</label>
            <select v-model="acc_action">
              <option
                :value="action"
                v-for="(action, idx) in actions"
                :key="idx"
              >
                {{ action }}
              </option>
            </select>
            <small> *You either choose location or the action </small>
          </div>
          <div class="post-item-wrap">
            <label for="modifier">Select a modifier:</label>
            <select id="modifier" v-model="acc_mod">
              <option
                :value="modifier"
                v-for="(modifier, idx) in modifiers"
                :key="idx"
              >
                {{ modifier }}
              </option>
            </select>
          </div>
          <div class="post-item-wrap">
            <label for="acc-desc">Selected action description:</label>
            <input v-model="acc_desc" type="text" id="acc-desc" />
          </div>
          <div class="post-item-wrap">
            <label for="acc-text">Accessibility text:</label>
            <textarea id="acc-text" v-model="acc_text"></textarea>
          </div>
          <div class="acc-keys-wrapper">
            <label for="acc-keys"
              >Choose the keyset for the selected action</label
            >
            <input v-model="acc_keys" type="text" id="acc-keys" />
          </div>
          <button @click="postAccessibility">Submit</button>
        </div>
      </div>
      <div class="single-accessibility">
        <h2>Delete accessibility</h2>
        <div class="post-item-wrap">
          <label for="delete-acc"> Select accessibility to delete: </label>
          <select id="delete-acc" v-model="acc_id">
            <option value="" selected disabled hidden>
              Choose accessibility to delete
            </option>
            <option
              v-for="el in accessibilitiesArr"
              :key="el.acc_id"
              :value="el.acc_id"
            >
              {{ el.acc_id }} {{ el.acc_desc }}
            </option>
          </select>
        </div>
        <button @click="deleteAccessibility">Delete</button>
      </div>
      <div class="single-accessibility">
        <h2>Edit accessibility</h2>
        <button class="showButton" v-if="postNew" @click="setPostNew(false)">
          Edit accessibility
        </button>
        <div v-if="!postNew">
          <div class="post-item-wrap">
            <label for="delete-acc"> Select accessibility to edit: </label>
            <select
              id="delete-acc"
              @change="checkAccType()"
              v-model="editAccId"
            >
              <option value="" selected disabled hidden>
                Choose accessibility to delete
              </option>
              <option
                v-for="el in accessibilitiesArr"
                :key="el.acc_id"
                :value="el.acc_id"
              >
                {{ el.acc_id }} {{ el.acc_desc }}
              </option>
            </select>
          </div>
          <div class="post-item-wrap" v-if="hideEditElements">
            <label for="acc-dropdown">Select the location:</label>
            <select id="acc-dropdown" v-model="loc_id">
              <option
                v-for="el in locations"
                :key="el.loc_id"
                :value="el.loc_id"
              >
                {{ el.loc_id }}. {{ el.loc_name }} ({{
                  el.ltp_code ? el.ltp_code : ""
                }})
              </option>
            </select>
            <small> *You either choose location or the action </small>
          </div>
          <div class="post-item-wrap" v-if="!hideEditElements">
            <label for="post-item-wrap">Select the action:</label>
            <select v-model="acc_action">
              <option
                :value="action"
                v-for="(action, idx) in actions"
                :key="idx"
              >
                {{ action }}
              </option>
            </select>
            <small> *You either choose location or the action </small>
          </div>
          <div class="post-item-wrap">
            <label for="modifier">Select a modifier:</label>
            <select id="modifier" v-model="acc_mod">
              <option
                :value="modifier"
                v-for="(modifier, idx) in modifiers"
                :key="idx"
              >
                {{ modifier }}
              </option>
            </select>
          </div>
          <div class="post-item-wrap">
            <label for="acc-desc">Selected action description:</label>
            <input v-model="acc_desc" type="text" id="acc-desc" />
          </div>
          <div class="post-item-wrap">
            <label for="acc-text">Accessibility text:</label>
            <textarea id="acc-text" v-model="acc_text"></textarea>
          </div>
          <div class="acc-keys-wrapper">
            <label for="acc-keys"
              >Choose the keyset for the selected action</label
            >
            <input v-model="acc_keys" type="text" id="acc-keys" />
          </div>
          <button @click="patchAccessibility">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      accessibilitiesArr: [],
      actions: ["Agenda", "Networking", "Home"],
      modifiers: ["ctrl", "shift", "ctrl+shift"],
      locations: [],
      loc_id: null,
      acc_desc: "",
      acc_text: "",
      acc_keys: "",
      acc_mod: "shift",
      acc_action: null,
      acc_id: "",
      editAccId: null,
      hideEditElements: false,
      postNew: true,
    };
  },
  watch: {
    loc_id(val) {
      if (val) this.acc_action = null;
    },
    acc_action(val) {
      if (val) this.loc_id = null;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this.getAccessibility();
      await this.getLocations();
    },
    async getLocations() {
      try {
        const res = await api.getAgendaLocations();
        this.locations = res.data.result;
      } catch (error) {
        console.log(error);
      }
    },
    async getAccessibility() {
      try {
        const res = await api.getAccessibility();
        this.accessibilitiesArr = res.data.res;
        console.log(this.accessibilitiesArr);
      } catch (error) {
        this.handleError(error);
      }
    },
    async postAccessibility() {
      const data = {
        loc_id: this.loc_id ? this.loc_id : null,
        acc_action: this.acc_action,
        acc_mod: this.acc_mod,
        acc_desc: this.acc_desc,
        acc_text: this.acc_text,
        acc_keys: this.acc_keys,
      };
      try {
        const res = await api.postAccessibility(data);
        console.log(res);
        this.clear()
        await this.getAccessibility();
        this.openToast("Success");
      } catch (error) {
        this.handleError(error);
      }
    },
    async deleteAccessibility() {
      const data = {
        acc_id: this.acc_id,
      };
      try {
        const res = await api.deleteAccessibility(data);
        this.openToast("Success");
        this.acc_id = "";
        await this.getAccessibility();
        console.log(res);
      } catch (error) {
        this.handleError(error);
      }
    },
    async patchAccessibility() {
      const data = {
        acc_id: this.editAccId,
        loc_id: this.loc_id ? this.loc_id : null,
        acc_action: this.acc_action,
        acc_mod: this.acc_mod,
        acc_desc: this.acc_desc,
        acc_text: this.acc_text,
        acc_keys: this.acc_keys,
      };
      try {
        const res = api.patchAccessibility(data);
        this.clear()
        await this.getAccessibility();
        this.openToast("Success");
      } catch (error) {
        this.handleError(error);
      }
    },

    checkAccType() {
      console.log(this.editAccId);
      this.accessibilitiesArr.forEach((el) => {
        if (el.acc_id == this.editAccId) {
          console.log("found it", el);
          if (!el.loc_id) {
            this.hideEditElements = false;
          } else {
            this.hideEditElements = true;
          }

          this.loc_id = el.loc_id ? el.loc_id : null;
          this.acc_action = el.acc_action;
          this.acc_mod = el.acc_mod;
          this.acc_desc = el.acc_desc;
          this.acc_text = el.acc_text;
          this.acc_keys = el.acc_keys;

          return;
        }
      });
    },
    setPostNew(bool) {
      this.postNew = bool;
        this.clear()
    },
    clear(){
        this.loc_id = "";
        this.acc_mod = "";
        this.acc_desc = "";
        this.acc_text = "";
        this.acc_keys = "";
        this.acc_mod = "shift";
        this.acc_action = null;

    }
  },
};
</script>

<style scoped lang='scss'>
.accessibility {
  padding: 50px;
  h1 {
    text-align: center;
    margin-bottom: 30px;
  }
  .wrapper {
    display: flex;
    .single-accessibility {
      width: calc(100% / 3);
      margin: 0 30px 0 0;
      .post-item-wrap {
        margin: 30px 0;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
      }
      .acc-keys-wrapper {
        width: 100%;
      }
      h2 {
        text-align: center;
      }
      button {
        display: block;
        margin: 30px 0;
      }
      .showButton {
        margin: 0 auto;
        display: block;
      }
    }
    select,
    textarea {
      width: 100%;
    }
    h2 {
      text-align: center;
    }
  }
}
</style>